import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'map-summary-container',
  templateUrl: './map-summary.component.html',
  styleUrls: ['./map-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MapSummaryComponent implements OnInit, OnDestroy {
  selection;

  @Input()
  set diagramSelection(selection) {
    if (_.isNil(selection)) { return; }

    this.selection = selection;
    const shapes = selection.nodes;
    const connections = selection.edges;

    if (shapes.length === 1 && connections.length === 0) {
      if (shapes[0].shapeType === 'node') {
        this.showView('node');
      } else if (shapes[0].shapeType === 'voipPeer') {
        this.showView('voipPeer');
      } else if ('cluster') {
        this.showView('voipPeerAggregation');
      }
    } else if (connections.length === 1 && shapes.length === 0) {
      if (connections[0].connectionType === 'connection') {
        this.showView('connection');
      } else if (connections[0].connectionType === 'peerConnection') {
        this.showView('peerConnection');
      } else {
        this.showView('peerConnectionAggregation');
      }
    } else if (connections.length === 0 && shapes.length === 0) {
      this.showView('');
    } else {
      this.showView('multipleSelection');
    }
  }

  constructor() {
  }

  viewToShowObject: any = {};

  ngOnInit(): void {
    this.showView('');
    /*this.sharedEventService.on(this, 'testRouteRefresh', () => {
      this.showView('');
    });*/
    /*this.sharedEventService.on(this, 'onlineDiagramSelectionChanged', (event, shapes, connections) => {
      if (shapes.length === 1 && connections.length === 0) {
        if (shapes[0].shapeType === 'node') {
          this.showView('node');
        } else if (shapes[0].shapeType === 'voipPeer') {
          this.showView('voipPeer');
        } else if ('cluster') {
          this.showView('voipPeerAggregation');
        }
      } else if (connections.length === 1 && shapes.length === 0) {
        if (connections[0].connectionType === 'connection') {
          this.showView('connection');
        } else if (connections[0].connectionType === 'peerConnection') {
          this.showView('peerConnection');
        } else {
          this.showView('peerConnectionAggregation');
        }
      } else if (connections.length === 0 && shapes.length === 0) {
        this.showView('');
      } else {
        this.showView('multipleSelection');
      }
    });*/
  }

  scopeDestroyForBroadcasts = () => {};
  ngOnDestroy(): void {
    this.scopeDestroyForBroadcasts();
  }

  private disableAllViews(): void {
    this.viewToShowObject.noSelection = false;
    this.viewToShowObject.multipleSelection = false;
    this.viewToShowObject.nodeSelection = false;
    this.viewToShowObject.voipPeerSelection = false;
    this.viewToShowObject.voipPeerAggregationSelection = false;
    this.viewToShowObject.connectionSelection = false;
    this.viewToShowObject.peerConnectionSelection = false;
    this.viewToShowObject.peerConnectionAggregationSelection = false;
  }

  private showView(viewName): void {
    switch (viewName) {
      case 'node':
        this.disableAllViews();
        this.viewToShowObject.nodeSelection = true;
        this.viewToShowObject.title = 'Node Summary';
        break;
      case 'voipPeer':
        this.disableAllViews();
        this.viewToShowObject.voipPeerSelection = true;
        this.viewToShowObject.title = 'Voip Peer Summary';
        break;
      case 'voipPeerAggregation':
        this.disableAllViews();
        this.viewToShowObject.voipPeerAggregationSelection = true;
        this.viewToShowObject.title = 'Cluster Summary';
        break;
      case 'connection':
        this.disableAllViews();
        this.viewToShowObject.connectionSelection = true;
        this.viewToShowObject.title = 'Connection Summary';
        break;
      case 'peerConnection':
        this.disableAllViews();
        this.viewToShowObject.peerConnectionSelection = true;
        this.viewToShowObject.title = 'Peer Connection Summary';
        break;
      case 'peerConnectionAggregation':
        this.disableAllViews();
        this.viewToShowObject.peerConnectionAggregationSelection = true;
        this.viewToShowObject.title = 'Peer Connection Aggregation Summary';
        break;
      case 'multipleSelection':
        this.disableAllViews();
        this.viewToShowObject.multipleSelection = true;
        this.viewToShowObject.title = '';
        break;
      default:
        this.disableAllViews();
        this.viewToShowObject.noSelection = true;
        this.viewToShowObject.title = 'Network Summary';
    }
  }
}
